import { AxiosPromise, AxiosResponse, AxiosError } from 'axios';
import { ProviderSearch } from './providerSearch';

enum p {
  SET_SEARCH_INPUT = 'SET_SEARCH_INPUT',
  FETCH_PROVIDER_DATA = 'FETCH_PROVIDER_DATA',
  FETCH_PROVIDER_DATA_PENDING = 'FETCH_PROVIDER_DATA_PENDING',
  FETCH_PROVIDER_DATA_FULFILLED = 'FETCH_PROVIDER_DATA_FULFILLED',
  FETCH_PROVIDER_DATA_REJECTED = 'FETCH_PROVIDER_DATA_REJECTED',
  SET_SORT_BY = 'SET_SORT_BY',
  SET_RECOMMENDATION = 'SET_RECOMMENDATION',
  SET_ENTITY_TYPE = 'SET_ENTITY_TYPE',
  SET_ACTION_INITIATED = 'SET_ACTION_INITIATED',
  SET_SELECTED_PROVIDER_ID = 'SET_SELECTED_PROVIDER_ID',
  CREATE_PROVIDER_EXPERIENCE = 'CREATE_PROVIDER_EXPERIENCE',
  CREATE_PROVIDER_EXPERIENCE_PENDING = 'CREATE_PROVIDER_EXPERIENCE_PENDING',
  CREATE_PROVIDER_EXPERIENCE_FULFILLED = 'CREATE_PROVIDER_EXPERIENCE_FULFILLED',
  CREATE_PROVIDER_EXPERIENCE_REJECTED = 'CREATE_PROVIDER_EXPERIENCE_REJECTED',
  UPDATE_PROVIDER_EXPERIENCE = 'UPDATE_PROVIDER_EXPERIENCE',
  UPDATE_PROVIDER_EXPERIENCE_PENDING = 'UPDATE_PROVIDER_EXPERIENCE_PENDING',
  UPDATE_PROVIDER_EXPERIENCE_FULFILLED = 'UPDATE_PROVIDER_EXPERIENCE_FULFILLED',
  UPDATE_PROVIDER_EXPERIENCE_REJECTED = 'UPDATE_PROVIDER_EXPERIENCE_REJECTED',
}

export type FetchProviderData = {
  type: typeof p.FETCH_PROVIDER_DATA;
  payload: AxiosPromise<ProviderSearch>;
};

type FetchProviderDataPending = {
  type: typeof p.FETCH_PROVIDER_DATA_PENDING;
  payload: AxiosPromise<ProviderSearch>;
};

type FetchProviderDataRejected = {
  type: typeof p.FETCH_PROVIDER_DATA_REJECTED;
  payload: AxiosError<ProviderSearch>;
};

type FetchProviderDataFulfilled = {
  type: typeof p.FETCH_PROVIDER_DATA_FULFILLED;
  payload: AxiosResponse<ProviderSearch>;
};

export type CreateProviderSearch = {
  type: typeof p.CREATE_PROVIDER_EXPERIENCE;
  payload: AxiosPromise<any>;
};

type CreateProviderSearchPending = {
  type: typeof p.CREATE_PROVIDER_EXPERIENCE_PENDING;
  payload: AxiosPromise<any>;
};

type CreateProviderSearchRejected = {
  type: typeof p.CREATE_PROVIDER_EXPERIENCE_REJECTED;
  payload: AxiosError<any>;
};

type CreateProviderSearchFulfilled = {
  type: typeof p.CREATE_PROVIDER_EXPERIENCE_FULFILLED;
  payload: AxiosResponse<any>;
};

export type UpdateProviderSearch = {
  type: typeof p.UPDATE_PROVIDER_EXPERIENCE;
  payload: AxiosPromise<any>;
};

type UpdateProviderSearchPending = {
  type: typeof p.UPDATE_PROVIDER_EXPERIENCE_PENDING;
  payload: AxiosPromise<any>;
};

type UpdateProviderSearchRejected = {
  type: typeof p.UPDATE_PROVIDER_EXPERIENCE_REJECTED;
  payload: AxiosError<any>;
};

type UpdateProviderSearchFulfilled = {
  type: typeof p.UPDATE_PROVIDER_EXPERIENCE_FULFILLED;
  payload: AxiosResponse<any>;
};

interface SetSearchInput {
  type: typeof p.SET_SEARCH_INPUT;
  payload: string;
}

interface SetSortBy {
  type: typeof p.SET_SORT_BY;
  payload: string;
}

interface SetRecommendation {
  type: typeof p.SET_RECOMMENDATION;
  payload: string;
}

interface SetEntityType {
  type: typeof p.SET_ENTITY_TYPE;
  payload: string;
}

interface SetActionInitiated {
  type: typeof p.SET_ACTION_INITIATED;
  payload: string;
}

interface SetSelectedProviderId {
  type: typeof p.SET_SELECTED_PROVIDER_ID;
  payload: string;
}

type FetchProviderDataAction =
  | FetchProviderData
  | FetchProviderDataPending
  | FetchProviderDataFulfilled
  | FetchProviderDataRejected;

type SetFilterAction =
  | SetSearchInput
  | SetSortBy
  | SetRecommendation
  | SetEntityType
  | SetActionInitiated
  | SetSelectedProviderId;

type ManipulateProviderAction =
  | CreateProviderSearch
  | CreateProviderSearchPending
  | CreateProviderSearchRejected
  | CreateProviderSearchFulfilled
  | UpdateProviderSearch
  | UpdateProviderSearchPending
  | UpdateProviderSearchRejected
  | UpdateProviderSearchFulfilled;

export type ProviderSearchActionTypes =
  | FetchProviderDataAction
  | SetFilterAction
  | ManipulateProviderAction;

export default p;
